import { createSelector } from 'reselect';
import { DebugOptions } from '../constants';
import { keyIn } from '../utils/immutable';
import { stateSelectorSwitcher } from '../utils/selectorUtils';
import { getIsUngatedForGlobalStylesTesting } from './authSelectors';
const DEBUG_OPTION_KEYS = Object.values(DebugOptions || {});
export const getDebugMode = state => state.app.get('debugMode');
const getApp = state => {
  return stateSelectorSwitcher(state, 'app');
};
export const getDebugOptions = state => getApp(state).filter(keyIn(...DEBUG_OPTION_KEYS)).toJS();
export const getTestMode = state => getApp(state).get('testMode') === 'true';
export const getGlobalStylesTestMode = state => getApp(state).get('globalStylesTestMode') === 'true';
export const getIsTestingGlobalStyles = createSelector([getGlobalStylesTestMode, getIsUngatedForGlobalStylesTesting], (globalStylesTestMode, isUngatedForGlobalStylesTesting) => globalStylesTestMode && isUngatedForGlobalStylesTesting);
export const getJavaScriptIntegrationEnabled = state => getApp(state).get(DebugOptions.JAVASCRIPT_INTEGRATION);
export const getRedirectUrl = state => getApp(state).get('redirectUrl');
export const getFocusedFieldKeys = state => getApp(state).get('focusedFieldKeys').toJS();
export const getPreviewIframeLoaded = state => getApp(state).get('previewIframeLoaded');
export const getInitialIframeLoadExecuted = state => getApp(state).get('initialIframeLoadExecuted');
export const getPreviewCacheBust = state => getApp(state).get('previewCacheBust');
export const getPreviewTemplatePathFromProps = (state, props) => props.previewTemplatePath;
export const getPreviewPageIdFromProps = (state, props) => props.previewPageId;
export const getSelectedPreviewAssetValue = createSelector([getPreviewPageIdFromProps, getPreviewTemplatePathFromProps], (previewPageIdFromProps, selectedTemplatePath) => previewPageIdFromProps || selectedTemplatePath);
export const getIframeLoadTimedOut = state => getApp(state).get('iframeLoadTimedOut');
export const getFromAppName = state => getApp(state).get('fromAppName');
export const getBusinessUnitId = state => getApp(state).get('businessUnitId');
export const getPreviewiframeReady = state => getApp(state).get('previewIframeReady');
export const getSelectedBreakpoint = state => getApp(state).get('selectedBreakpoint');
export const getIsPresetPanelOpen = state => {
  const app = getApp(state);
  return app && app.get ? app.get('isPresetPanelOpen') : false;
};
export const getIsPortalsHmrReady = state => getApp(state).get('isPortalsHmrReady');